export default "__VITE_ASSET__DFt$jMyc__"